import moment from "moment";

export function workLocationLabel(wl) {
  if (wl === "wfh") return "WFH";
  if (wl === "wfs") return "WFS";
  if (wl === "wfo") return "WFO";
  return "—";
}

export function statusLabel(status) {
  const map = {
    present: "Present",
    late: "Late",
    wfh: "WFH",
    wfs: "WFS",
    half_day: "Half Day",
    early_leave: "Early Leave",
    on_leave: "On Leave",
    leave_pending: "Leave (pending)",
    holiday: "Holiday",
    week_off: "Week off",
    absent: "Absent",
    in_progress: "Present",
    on_time: "Present",
    upcoming: "—",
  };
  return map[status] || status || "-";
}

export function statusPillClass(status) {
  const map = {
    present: "att-pill att-pill--present",
    on_time: "att-pill att-pill--present",
    late: "att-pill att-pill--late",
    wfh: "att-pill att-pill--wfh",
    wfs: "att-pill att-pill--wfs",
    half_day: "att-pill att-pill--half",
    early_leave: "att-pill att-pill--leave",
    on_leave: "att-pill att-pill--leave",
    leave_pending: "att-pill att-pill--leave-pending",
    holiday: "att-pill att-pill--holiday",
    week_off: "att-pill att-pill--muted",
    absent: "att-pill att-pill--absent",
    in_progress: "att-pill att-pill--present",
    upcoming: "att-pill att-pill--empty",
  };
  return map[status] || "att-pill att-pill--muted";
}

export function formatHm(mins) {
  if (mins == null || Number.isNaN(Number(mins))) return "-";
  const m = Math.max(0, Math.round(Number(mins)));
  return `${Math.floor(m / 60)}h ${m % 60}m`;
}

export function formatPunch(ts) {
  if (!ts) return "-";
  return moment(ts).format("hh:mm A");
}

/** Whether today's first punch counts as on-time (not late). */
export function todayArrivalLabel(status) {
  if (!status) return "—";
  if (status === "late") return "Late";
  if (["present", "wfh", "wfs", "half_day", "early_leave", "in_progress"].includes(status)) {
    return "On time";
  }
  if (status === "absent") return "Absent";
  if (status === "on_leave") return "On leave";
  if (status === "holiday") return "Holiday";
  if (status === "week_off") return "Week off";
  return statusLabel(status);
}

/** Build month grid weeks (Sun–Sat) for `month` Date */
export function buildMonthGrid(monthMoment) {
  const start = monthMoment.clone().startOf("month").startOf("week");
  const end = monthMoment.clone().endOf("month").endOf("week");
  const weeks = [];
  let cur = start.clone();
  while (cur.isSameOrBefore(end)) {
    const week = [];
    for (let i = 0; i < 7; i++) {
      week.push(cur.clone());
      cur.add(1, "day");
    }
    weeks.push(week);
  }
  return weeks;
}
